{
  "slug": "how-is-iq-measured",
  "title": "¿Cómo se mide el CI?",
  "description": "Comprenda las pruebas de CI estandarizadas, las normas basadas en la edad, las subpruebas, los percentiles y por qué cada resultado tiene un margen de error.",
  "summary": "El coeficiente intelectual se mide con tareas cognitivas estandarizadas, el rendimiento bruto se compara con las normas basadas en la edad y se convierte en una puntuación, comúnmente centrada en. 100.",
  "sections": [
    {
      "heading": "De las tareas a una puntuación estandarizada",
      "paragraphs": [
        "Una evaluación contiene múltiples subpruebas, por ejemplo, la capacidad de identificar patrones, manipular información en la memoria, resolver problemas verbales o trabajar con precisión bajo límites de tiempo. Los totales brutos tienen poco significado por sí solos, por lo que los editores los comparan con una muestra de referencia grande.",
        "El rendimiento se compara con personas del mismo grupo de edad y las puntuaciones de las subpruebas escaladas se pueden combinar en puntuaciones de índice más amplias y una estimación general."
      ]
    },
    {
      "heading": "Normas, percentiles y dispersión",
      "paragraphs": [
        "Muchas pruebas actuales utilizan una media de 100 y una desviación estándar de. 15. Un percentil expresa la posición: 100 Está cerca de la. 5010º percentil, mientras que 120 Es alrededor de la. 911er percentil bajo una distribución normal.",
        "Diferentes instrumentos utilizan diferentes tareas y normas, por lo que dos pruebas válidas no siempre producen puntuaciones idénticas."
      ]
    },
    {
      "heading": "Por qué la interpretación importa",
      "paragraphs": [
        "Cada puntaje incluye incertidumbre de medición y por lo general debe ser reportado con un intervalo de confianza.Un examinador capacitado también considera los patrones de subprueba, el idioma, el origen cultural, las condiciones de la prueba y el propósito de la evaluación.",
        "Una buena medición depende de las instrucciones estándar, las normas adecuadas, la seguridad de la prueba, la fiabilidad y la validez, y un número sin este contexto puede ser engañoso."
      ]
    }
  ],
  "faqs": [
    {
      "question": "¿Por qué algunas tareas de QI son cronometradas?",
      "answer": "Algunas subpruebas miden la eficiencia de procesamiento, pero muchas tareas de razonamiento no tienen tiempo o tienen límites generosos, y el tiempo es solo una parte de una evaluación."
    },
    {
      "question": "¿Pueden diferentes pruebas de CI dar resultados diferentes?",
      "answer": "El contenido, las normas, el error de medición, la salud y las condiciones de prueba pueden causar diferencias razonables."
    }
  ],
  "related": ["what-is-iq", "what-is-the-average-iq", "iq-score-ranges-explained"]
}
